import DashboardLayout from "../../../layouts/DashboardLayout";
import FuncionarioStats from "../../../components/Funcionario/FuncionarioStats/FuncionarioStats";
import FuncionarioCertificados from "../../../components/Funcionario/FuncionarioCertificados/FuncionarioCertificados";
import FuncionarioActividad from "../../../components/Funcionario/FuncionarioActividad/FuncionarioActividad";
import styles from "../styles/FuncionarioDashboard.module.css";

function DashboardFuncionario() {
    return (
        <DashboardLayout>
            <div className={styles.dashboardContainer}>
                <FuncionarioStats />
                <div className={styles.gridContainer}>
                    <FuncionarioCertificados />
                </div>
                <FuncionarioActividad />
            </div>
        </DashboardLayout>
    );
}

export default DashboardFuncionario;
